window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// import "node_modules/bootstrap/js/src/modal.js";
// import "`bootstrap/dist/js/bootstrap.js";
import "../../node_modules/bootstrap";
import './slick';
import './backToTop';
import './navBar';
import './jvalid';
// import './bootstrap';
import './lightgallery';
import './megamenu';
import './hamburger';
import './search';
import './menu_left';
// import './powloki';
// import './initMap';
import './map';
import './map_dys';
// import './restauracja';
// import './koszyk_rowiniety';
// import './rukola';
//import './modal';
// import './podsumowanie';
// import './accordion';
import './news';
// import './collapse';
import './liczydlo';
import './wcag';
import './wcag_v2';
import './tabs';
import './wodo';
//import './modal';
import './wodo_podlicznik';


$(window).on('load', function() {
    // Animate loader off screen
    // $("#loader").animate({
    //     top: -200
    // }, 1500);
    $('body').css('opacity', 1);
    // console.log('ok');
});

if ("ontouchstart" in document.documentElement) {
    $('.typy_menu_flex').addClass('filtry_over');
} 
// else {
//     $('.typy_menu_flex').addClass('filtry_flex');
// }


$(document).ready(function () {
 if ( $('.zaladowany_plik').length)  {
        document.getElementById("file").onchange = function () {
            $('.zaladowany_plik').css('display', 'block');
            $('.zaladowany_plik span').text( this.value.replace("C:\\fakepath\\", "") );
            // $('.btn-none').css('display', 'block');
        };
    }

$('.slider_more').on('click', function() {
    $("html, body").animate({ scrollTop: $('#slider_more_hand').offset().top }, 1000);
})
// $('.strzalka').on('click', function() {
//     console.log('as');

//     $('.change_selectAdresRest').attr('size',4);

//     // $('.change_selectAdresRest').show().focus().click();
// })

if ($('.nav_hraf_products').length) {
    fixedPositionNavHraf();
    var kotwica = $('.nav_hraf_products .container .lista_nag');
    var naglowki = $('.product__nag');
    for (var i = 0; i < naglowki.length; i++) {
        $(naglowki[i]).attr('id', convertToSlug($(naglowki[i]).text()));
        kotwica.append('<div data-slug="'+convertToSlug($(naglowki[i]).text())+'" class="scrollToElement lista_nag_poj">'+$(naglowki[i]).text()+'</div>');
    }

}
});
$(document).ready(function () {
$('#app').on('click', '.scrollToElement', function() {
    var slug = $(this).data('slug');
    var scroll_h = $(window).scrollTop();
    var elem = $('#app #'+slug);
    var position = elem.offset();

    if (scroll_h >= position.top) {
        var odejmij = 355;
    }else {
        var odejmij = 185;
    }

    $('html,body').animate({
        scrollTop: $('#'+slug).offset().top - odejmij
    }, 1000);
})
})

$(window).scroll(function() {
    fixedPositionNavHraf();
});

function fixedPositionNavHraf() {
    var scroll_h = $(window).scrollTop();
    var elem = $('.wrap_nav_hraf');
    if (elem.length) {
        var position = elem.position();
        if (scroll_h >= position.top) {
            $('.nav_hraf_products').addClass('position_fixed').addClass('shoder_kotwica');
        }else {
            $('.nav_hraf_products').removeClass('position_fixed').removeClass('shoder_kotwica');
        }
    }
}

function convertToSlug(Text)
{
    return Text
        .toLowerCase()
        .replace(/ /g,'-')
        .replace(/[^\w-]+/g,'')
        ;
}

$(document).ready(function () {
    [].forEach.call(document.querySelectorAll('img[data-src]'), function (img) {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.onload = function () {
            img.removeAttribute('data-src');
        };
    });
let click = $('.js-menu');

click.on('click', function () {

    $(this).next().slideToggle(200);
    // $(this).toggleClass('active');
    $(this).parents('li').toggleClass('no-border');
});

$('.btn_dalej').on('click', function() {
    $("html, body").animate({ scrollTop: $('#goto_btn_dalej').offset().top + 35 }, 1000);
})
});

mobileMenuInit();

function mobileMenuInit()
{
    $('#mobile-menu-btn').on('click', function (e)
    {
        if ($('#mobile-menu').hasClass('mobile-expanded'))
        {
            $('#mobile-menu').removeClass('mobile-expanded');
            $('#mobile-menu-overlay').removeClass('mobile-expanded');
        }
        else
        {
            $('#mobile-menu').addClass('mobile-expanded');
            $('#mobile-menu-overlay').addClass('mobile-expanded');
        }
    });
    $('.svg-menu-down').on('click', function (e)
    {
        if ($(this).hasClass('expanded'))
        {
            $(this).removeClass('expanded');
            $(this).siblings('ul.submenu').removeClass('expanded');
        } else
        {
            $(this).addClass('expanded');
            $(this).siblings('ul.submenu').addClass('expanded');
        }
    });
}
$(document).ready(function () {
$('.collapsible').on('click', function() {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next().removeClass('active');
    }else {
        $(this).addClass('active');
        $(this).next().addClass('active');
    }
})
})

function animacjeScroll() {
    $('.mg_aos').each(function(){
        if(isScrolledIntoView($(this))){
            var animation = $(this).data('aniamtion')
            $(this).addClass(animation);
        }
    });
}

$(document).ready(function() {
    animacjeScroll();

});



$(window).scroll(function(){
  animacjeScroll();

});

function isScrolledIntoView(elem){
    var $elem = $(elem);
    var $window = $(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();
    // console.log(docViewTop, docViewBottom);

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();
    // console.log(elemTop, elemBottom);

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(document).ready(function () {

if ($('.zalacznik').length) {

    $('#app').on('change', '.zalacznik', function() {

        var names = '';
        for (var i = 0; i < $(this).get(0).files.length; ++i) {
            names += '<div> '+$(this).get(0).files[i].name + '<span class="deleteRef" data-index="'+i+'"><svg xmlns="http://www.w3.org/2000/svg" width="12.122" height="13.792" viewBox="0 0 12.122 13.792"><g id="bin" transform="translate(0 -0.001)"><g id="Group_102" data-name="Group 102" transform="translate(0.841 4.042)"><g id="Group_101" data-name="Group 101"><path id="Path_588" data-name="Path 588" fill="#00c761" d="M62.205,150l.716,8.64a1.219,1.219,0,0,0,1.207,1.112h6.594a1.219,1.219,0,0,0,1.207-1.112l.716-8.64Zm3.2,8.135a.4.4,0,0,1-.4-.379l-.4-6.519a.4.4,0,0,1,.378-.429.4.4,0,0,1,.429.378l.4,6.519A.4.4,0,0,1,65.4,158.135Zm2.425-.4a.4.4,0,0,1-.808,0v-6.519a.4.4,0,1,1,.808,0Zm2.424-6.494-.4,6.519a.4.4,0,1,1-.807-.051l.4-6.519a.411.411,0,0,1,.429-.378A.4.4,0,0,1,70.253,151.237Z" transform="translate(-62.205 -150)"/></g></g><g id="Group_104" data-name="Group 104" transform="translate(0 0.001)"><g id="Group_103" data-name="Group 103"><path id="Path_589" data-name="Path 589" fill="#00c761" d="M42.314,1.616H39.889v-.4A1.214,1.214,0,0,0,38.677,0H35.445a1.214,1.214,0,0,0-1.212,1.212v.4H31.808a.808.808,0,0,0,0,1.616H42.314a.808.808,0,1,0,0-1.616Zm-3.232,0H35.041v-.4a.4.4,0,0,1,.4-.4h3.232a.4.4,0,0,1,.4.4Z" transform="translate(-31)"/></g></g></g></svg></span><br></div>';
        }
        $(this).closest('.input_file').find('.input_file--p').html(names);
    })

    $('#app').on('click', '.deleteRef', function() {
        var index = $(this).data('index');
        var dt = new DataTransfer()


        var input = $(this).closest('.input_file').find('.zalacznik')[0];
        var files = input.files;
        // console.log(files)
        for (var i = 0; i < files.length; i++) {
            var file = files[i]
            if (index !== i) dt.items.add(file) 
            input.files = dt.files
        }
        // console.log(input.files)
        
        $(this).closest('div').remove();
    })
}


    if ( $('.dodaj_btn').length ) {

        $('.dodaj_btn').on('click', function() {
            $.get('/form/get-dodaj-pozycja').done(function(response) {
                $('.form-table--tutaj').append(response);

                addMultiInputNamingRules('#commentForm', 'input.nr_pozycji', { required:true });
                addMultiInputNamingRules('#commentForm', 'input.nazwa_towaru', { required:true });
                addMultiInputNamingRules('#commentForm', 'input.ilosc', { required:true });
                // addMultiInputNamingRules('#commentForm', 'input.nr_serii', { required:true });
                // addMultiInputNamingRules('#commentForm', 'input.data_waznosci', { required:true });
                addMultiInputNamingRules('#commentForm', 'select.powod_zgloszenia', { required:true });

            })
        })

        $('#app').on('click', '.form-table--usun', function() {
            $(this).closest('.form-table--table').remove();
        })

        $('#app').on('change', '.powod_zgloszenia', function() {
            var select = $('.powod_zgloszenia');
            // console.log(select);
            var check = false;
            for (var i = 0; i < select.length; i++) {
                // console.log( $(select[i]).val());
                if ($(select[i]).val() == "Wada jakościowa") {
                    check = true;
                }
            }
            if (check) {
                $('textarea[name="uwagi"]').prop('required', true);
            }else {
                $('textarea[name="uwagi"]').prop('required', false).removeClass('error');
                $('#uwagi-error').remove();
            }
        })
    }
});
function addMultiInputNamingRules(form, field, rules){    
    var inputy = $(field);
    // console.log(inputy);

    $(form).find(field).each(function(index){
        $(this).attr('alt', $(this).attr('name'));
        $(this).attr('name', $(this).attr('name')+'-'+index);
        $(this).rules('add', rules);
    });
}

$(document).ready(function() {

    $("#btn-send-reklamacja").on('click', function(){

        if ($("#commentForm").valid()) {

            setGoodNameInput('nr_pozycji');
            setGoodNameInput('nazwa_towaru');
            setGoodNameInput('ilosc');
            // setGoodNameInput('nr_serii');
            // setGoodNameInput('data_waznosci');
            setGoodNameInput('powod_zgloszenia');
           
            $("#commentForm").submit();
        }
    })
})

function setGoodNameInput(name) {
     $("input."+name).each(function(){
        $(this).attr('name', name + '[]');
    });
}